import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../api/supabase';
import { useAuth } from '../../context/AuthContext';

export default function SaleQuotationList() {
  const { isAgent, user } = useAuth();
  const username = user?.email?.split('@')[0] || '';
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    let query = supabase.from('sale_quotations').select('*').order('created_at', { ascending: false });
    if (isAgent) query = query.eq('created_by', username);
    query.then(({ data }) => { setRows(data || []); setLoading(false); });
  }, [isAgent, username]);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Quotations</div>
          <div className="page-subtitle">Package offers and per-pax rates — marketing documents only</div>
        </div>
        <Link to="/sale-quotations/new" className="btn btn-primary">+ New Quotation</Link>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {loading ? <div className="spinner" style={{ padding: 24 }} /> : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Ref #</th>
                  <th>Title / Package</th>
                  <th>Destination</th>
                  <th>Per Pax Rate</th>
                  <th>Valid Until</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map(q => (
                  <tr key={q.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 13 }}>{q.quotation_number}</td>
                    <td style={{ fontWeight: 600 }}>{q.title || '—'}</td>
                    <td style={{ color: 'var(--text-muted)', fontSize: 13 }}>{q.destination || '—'}</td>
                    <td>{q.per_pax_rate ? `${q.currency_code} ${parseFloat(q.per_pax_rate).toLocaleString()}` : '—'}</td>
                    <td style={{ fontSize: 13 }}>{q.valid_until || '—'}</td>
                    <td><span className={`badge ${q.status === 'SENT' ? 'badge-green' : 'badge-gray'}`}>{q.status}</span></td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <Link to={`/sale-quotations/${q.id}`} className="btn btn-sm btn-secondary">View</Link>
                      </div>
                    </td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr><td colSpan={7}><div className="empty-state"><div className="empty-state-title">No quotations yet</div></div></td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
